<template>
  <div class="employerItem" @click="goToDetail()">
    <div class="top">
		<div class="img-wrap">
			<img :src="item.enterpriseLogo | avatar('company')" v-img-error-company/>	
		</div>
    	<div class="info">
    		<h2 class="van-ellipsis">{{item.shortName || item.enterpriseName}}</h2>
    		<div class="company">
	    		<span class="line" v-if="item.developStatusStr">{{item.developStatusStr}}</span>
	    		<span class="line" v-if="item.enterpriseIndustries">{{item.enterpriseIndustries | industry}}</span>
	    	</div>
    	</div>
    </div>
    <ul class="data" v-if="item.statistics">
    	<li>
    		<p>{{item.statistics.positionCount || 0}}</p>
    		<p class="desc">在线职位</p>
    	</li>
    	<li>
    		<p>{{item.statistics.offerCount || 0}}</p>
    		<p class="desc">成单数</p>
    	</li>
    	<li>
    		<p>{{item.statistics.recommendFeedbackTime | withdrawFeedbackTime}}</p>
    		<p class="desc">反馈时长</p>
    	</li>
    </ul>
    <van-divider v-if="item.functionModelList && item.functionModelList.length">该雇主热招职能</van-divider>
    <div class="tags-content" v-if="item.functionModelList && item.functionModelList.length">
    	<span class="tag" v-for="tag in item.functionModelList" >{{tag.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "employerItem",
  props: {
  	item: {
  		default(){
  			return {}
  		}
  	}
  },
  components: {},
  methods: {
  	goToDetail(){
  		let url = '/employerDetail/'+this.item.enterpriseId;
        this.$router.push(url);
  	}
  },
  created() {}
};
</script>

<style lang="scss" scoped>
	.employerItem{
		padding: 15px;
		background: #fff;
		margin-bottom: 10px;
		.top{
			padding-bottom: 15px;
			border-bottom: 0.5px solid #E5E5E5;
			display: flex;
			.img-wrap{
				margin-right: 15px;
				border-radius: 4px;
				overflow: hidden;
				height: 60px;
    			width: 60px;
    			line-height: 60px;
    			text-align: center;
    			vertical-align: middle;
    			background-color: #fafafa;
    			flex-shrink: 0;
    			img{

    			}
			}
			.info{
				width: 100%;
				h2{
					font-size: 16px;
					color: #333333;
					line-height: 20px;
					margin-bottom: 15px;
					max-width: 256px;
					display: inline-block;
				}
				div.company{
					font-size: 12px;
					color: #666666;
					line-height: 15px;
					display: inline-block;
					width: 100%;
					span{
						position: relative;
						padding-right: 10px;
    				margin-right: 10px;
    				&:last-child{
    					padding-right: 0;
    					margin-right: 0;
    				};
						&.line{
							&:last-child{
								&:after{
									content: none;
								};
							};
							&:after{
								content: " ";
						    position: absolute;
						    right: 0;
						    top: 50%;
						    width: 1px;
						    height: 60%;
						    background-color: #E6E6E6;
						    -webkit-transform: translateY(-50%);
						    transform: translateY(-50%);
							};
						}
					}
				}
			}
		}
		.data{
			display: flex;
			padding: 20px 0 15px 0;
			li{
				flex-grow: 1;
				p{
					font-size: 16px;
					color: #333333;
					text-align: center;
					line-height: 15px;
					margin-bottom: 10px;
					&:last-child{
						margin-bottom: 0;
					};
					&.desc{
						font-size: 12px;
						color: #666666;
					}
				}
			}
		}
		.tags-content{
			margin-top: 15px;
			span{
				background: #F5F5F5;
				border-radius: 4px;
				border-radius: 4px;
				padding: 5px 14px;
				margin-right: 10px;
				font-size: 14px;
				color: #666666;
				text-align: center;
			}
		}
		.van-divider{
			margin: 0;
		}
	}
</style>

<style lang="scss">
	.employerItem .top .van-image{
		margin-right: 15px;
	    border-radius: 4px;
	    overflow: hidden;
	    flex-shrink: 0;
	}
</style>